import React, { Component } from "react";
import CSSClasses from "./PartialPayoutPopup.css";
import Auxx from "../../HOCs/AUXX/Auxx";
import { connect } from "react-redux";
import * as StoreActions from "../../ReduxStore/Actions/ActionIndex";
import NumericKeyboard, {
  ADJUSTED_FOR_PAYOUT_POPUP
} from "../Keyboards/NumericKeyboard/NumericKeyboard";

import * as DBEnums from "../../HOCs/Constants/DatabaseEnums";

import FullscreenModalPopup from "../../Components/UI/FullscreenModalPopup/FullscreenModalPopup";

import { PayoutToUserSession } from "../../Communication/PartialPayoutServicesHandler";

class PartialPayoutPopup extends Component {
  state = {
    isInPayout: false,
    isPayoutInProgess: false,
    isPayoutCompleted: false,
    isPayoutActionsPaused: false,
    isInTransferToSaldo: false,
    isTransferToSaldoCompleted: false,
    showsNumbericKeyboard: false,
    txtAmountPayoutValue: 0,
    totalDispendedAmount: 0,
    infoMessage: null,
    originalRealPayOutAmount: 0
  };

  K_TEXTBOX_AMOUNT = 1;

  componentDidMount() {
    window.addEventListener(
      "onReportMaxPayout",
      function(e) {
        this.checkMaxPayout_Callback(e.detail.amount);
      }.bind(this)
    );

    window.addEventListener(
      "onReportDispendedBill",
      function(e) {
        this.reportDispendedBill_Callback(e.detail.amount);
      }.bind(this)
    );

    this.setState({
      originalRealPayOutAmount: this.props.payoutReceiptInfo.RealPayOutAmountEUR
    });
  }

  reportDispendedBill_Callback = amount => {
    //ako trenutno nisi prikazan, return, nije za tebe!
    if (!(this.props.currentPayoutReceiptNumber > 1)) {
      return;
    }

    var totalPaidOut = this.state.totalDispendedAmount + amount;

    this.setState({
      totalDispendedAmount: totalPaidOut
    });

    if (totalPaidOut === this.state.txtAmountPayoutValue) {
      //prenesi na saldo visak
      this.props.addToBalance(
        (this.props.payoutReceiptInfo.AvailablePayOutAmountEUR -
          this.state.txtAmountPayoutValue) *
          100
      );

      this.setState({
        isPayoutInProgess: false,
        isPayoutCompleted: true,
        isPayoutActionsPaused: false
      });
    }
  };

  checkMaxPayout_Callback = amount => {
    //ako trenutno nisi prikazan, return, nije za tebe!
    if (!(this.props.currentPayoutReceiptNumber > 1)) {
      return;
    }

    if (amount !== this.state.txtAmountPayoutValue) {
      //alert("Kladomat moze isplatiti najvise " + amount + " BAM!");

      var msg = (
        <p>
          Kladomat može isplatiti najviše {amount} BAM!
          <br />
          <br />
          Zatražena isplata: {this.state.txtAmountPayoutValue} BAM
        </p>
      );

      this.setState({ infoMessage: msg });

      //ne moze sve sto je trazio, promijeni
      this.setState({ txtAmountPayoutValue: amount });
      return;
    }

    //proslo, znaci pokreni isplatu
    this.setState({ isPayoutInProgess: true, isPayoutActionsPaused: true });

    //pokreni paree
    window.cefCustomObject.payoutBillAmount(this.state.txtAmountPayoutValue);
  };

  render() {
    if (!this.props.payoutReceiptInfo) {
      return null;
    }

    return (
      <div className={CSSClasses.container}>
        <FullscreenModalPopup
          message={this.state.infoMessage}
          btnOkClickCallback={this.modalPopupBtnOk_Callback}
        />

        <div className={CSSClasses.popupBox}>
          <div className={CSSClasses.title}>
            {this.state.isPayoutCompleted
              ? "POTVRDA JE USPJEŠNO ISPLAĆENA!"
              : "POTVRDA ZA ISPLATU"}
          </div>
          <div className={CSSClasses.summaryRow}>
            Broj potvrde: {this.props.payoutReceiptInfo.ReceiptNumber}
          </div>
          <div className={CSSClasses.summaryRow}>
            Vrijednost potvrde:{" "}
            {this.props.payoutReceiptInfo.AvailablePayOutAmountEUR.toFixed(2) +
              this.props.machineInfo.CurrencyCode}
          </div>
          <div className={CSSClasses.summaryRow}>
            Dosad isplaćeno:{" "}
            {this.state.originalRealPayOutAmount.toFixed(2) +
              this.props.machineInfo.CurrencyCode}
          </div>
          <div className={CSSClasses.summaryRow}>
            Preostali iznos za isplatu:{" "}
            {(
              this.props.payoutReceiptInfo.AvailablePayOutAmountEUR -
              this.state.originalRealPayOutAmount
            ).toFixed(2) + this.props.machineInfo.CurrencyCode}
          </div>

          {!this.state.isInPayout &&
          !this.state.isInTransferToSaldo &&
          (this.props.payoutReceiptInfo.PayoutStatusID ===
            DBEnums.PAYOUT_STATUS_READY_FOR_PAYOUT ||
            this.props.payoutReceiptInfo.PayoutStatusID ===
              DBEnums.PAYOUT_STATUS_PARTIALLY_PAID_OUT) ? (
            <Auxx>
              <div className={CSSClasses.infoRow}>
                Novac s potvrde možete isplatiti ovisno o raspoloživom novcu u
                terminalu ili ga prebaciti na saldo.
                <br />
                Potvrdu za isplatu također možete unovčiti ili iskoristiti za
                igru u bilo kojoj WWin poslovnici.
              </div>
              <div className={CSSClasses.infoRow}>
                Odaberite radnju s kojom želite nastaviti:
              </div>
            </Auxx>
          ) : null}

          {this.props.payoutReceiptInfo.PayoutStatusID ===
          DBEnums.PAYOUT_STATUS_PAYOUT_COMPLETED ? (
            <Auxx>
              <div className={CSSClasses.infoRow}>
                Ova potvrda je iskorištena te ju više nije moguće isplatiti.
              </div>
            </Auxx>
          ) : null}

          {this.state.isInPayout &&
          !this.state.isPayoutInProgess &&
          !this.state.isPayoutCompleted ? (
            <Auxx>
              <div className={CSSClasses.instructions}>
                Unesite iznos koji želite isplatiti:
                <input
                  type="text"
                  className={[
                    CSSClasses.txtBetAmount,
                    this.state.currentTextboxID === this.K_TEXTBOX_AMOUNT
                      ? CSSClasses.txtActive
                      : ""
                  ].join(" ")}
                  value={this.state.txtAmountPayoutValue}
                  onClick={() => {
                    this.txtNumeric_Enter(this.K_TEXTBOX_AMOUNT);
                  }}
                  onSelect={ev => {
                    ev.target.selectionStart = ev.target.selectionEnd;
                  }}
                />
                <br />
                <span className={CSSClasses.remark}>
                  Napomena: Kladomat može isplatiti samo okrugle iznose!
                </span>
                <br />
                <br />
                Ostatak će biti prebačen na saldo.
                <br />
                Novac sa salda možete koristiti za igru ili ispisati potvrdu za
                isplatu u poslovnici ili na drugom kladomatu.
              </div>
            </Auxx>
          ) : null}

          {this.state.isInPayout &&
          this.state.isPayoutInProgess &&
          !this.state.isPayoutCompleted ? (
            <Auxx>
              <div className={CSSClasses.instructions}>
                U tijeku je isplata iznosa:{" "}
                {this.state.txtAmountPayoutValue.toFixed(2) +
                  this.props.machineInfo.CurrencyCode}
                <br />
                <br />
                Dosad isplaćeno:
                <br />
                <div className={CSSClasses.payoutCounter}>
                  {this.state.totalDispendedAmount}/
                  {this.state.txtAmountPayoutValue +
                    this.props.machineInfo.CurrencyCode}
                </div>
              </div>
            </Auxx>
          ) : null}

          {this.state.isInPayout &&
          !this.state.isPayoutInProgess &&
          this.state.isPayoutCompleted ? (
            <Auxx>
              <div className={CSSClasses.instructions}>
                Isplaćeno u gotovini:{" "}
                {this.state.txtAmountPayoutValue.toFixed(2) +
                  this.props.machineInfo.CurrencyCode}
                <br />
                <br />
                Preneseno na saldo:{" "}
                {(
                  this.props.payoutReceiptInfo.AvailablePayOutAmountEUR -
                  this.state.totalDispendedAmount
                ).toFixed(2)}
                {this.props.machineInfo.CurrencyCode}
                <br />
                <br />
              </div>
            </Auxx>
          ) : null}

          {this.state.isInTransferToSaldo &&
          !this.state.isTransferToSaldoCompleted ? (
            <Auxx>
              <div className={CSSClasses.infoRow}>
                {" "}
                Vrijednost vaše potvrde će biti prenesena na saldo kladomata.
                <br />
                Novac sa salda možete koristiti za igru ili ispisati potvrdu za
                isplatu u poslovnici ili na drugom kladomatu.
              </div>
            </Auxx>
          ) : null}

          {this.state.isInTransferToSaldo &&
          this.state.isTransferToSaldoCompleted ? (
            <Auxx>
              <div className={CSSClasses.infoRow}>
                <br />
                Novac je uspješno prenesen na saldo!
                <br />
                <br />
              </div>
            </Auxx>
          ) : null}

          {!this.state.isInPayout &&
          !this.state.isInTransferToSaldo &&
          (this.props.payoutReceiptInfo.PayoutStatusID ===
            DBEnums.PAYOUT_STATUS_READY_FOR_PAYOUT ||
            this.props.payoutReceiptInfo.PayoutStatusID ===
              DBEnums.PAYOUT_STATUS_PARTIALLY_PAID_OUT) ? (
            <div
              className={CSSClasses.baseBtn}
              onClick={() => {
                this.btnPayoutMoney_Click();
              }}
            >
              ISPLATI NOVAC
            </div>
          ) : null}

          {this.state.isInPayout && !this.state.isPayoutCompleted ? (
            <div
              className={CSSClasses.baseBtn}
              onClick={() => {
                this.btnConfirmPayoutMoney_Click();
              }}
            >
              {this.state.isPayoutActionsPaused ? "" : "POTVRDI"}
            </div>
          ) : null}

          {!this.state.isInPayout &&
          !this.state.isInTransferToSaldo &&
          (this.props.payoutReceiptInfo.PayoutStatusID ===
            DBEnums.PAYOUT_STATUS_READY_FOR_PAYOUT ||
            this.props.payoutReceiptInfo.PayoutStatusID ===
              DBEnums.PAYOUT_STATUS_PARTIALLY_PAID_OUT) ? (
            <div
              className={CSSClasses.baseBtn}
              onClick={() => {
                this.btnTransferToSaldo_Click();
              }}
            >
              PRENESI NA SALDO
            </div>
          ) : null}

          {this.state.isInTransferToSaldo &&
          !this.state.isTransferToSaldoCompleted ? (
            <div
              className={CSSClasses.baseBtn}
              onClick={() => {
                this.btnConfirmTransferToSaldo_Click();
              }}
            >
              POTVRDI
            </div>
          ) : null}

          <div
            className={[CSSClasses.baseBtn, CSSClasses.btnCancel].join(" ")}
            onClick={() => {
              this.btnCancel_Click();
            }}
          >
            {(this.state.isInPayout &&
              !this.state.isPayoutInProgess &&
              !this.state.isPayoutCompleted) ||
            (this.state.isInTransferToSaldo &&
              !this.state.isTransferToSaldoCompleted)
              ? "POVRATAK"
              : this.state.isTransferToSaldoCompleted ||
                this.state.isPayoutCompleted
              ? "ZATVORI"
              : this.state.isPayoutActionsPaused
              ? ""
              : this.props.payoutReceiptInfo.PayoutStatusID !==
                  DBEnums.PAYOUT_STATUS_READY_FOR_PAYOUT &&
                this.props.payoutReceiptInfo.PayoutStatusID !==
                  DBEnums.PAYOUT_STATUS_PARTIALLY_PAID_OUT
              ? "ZATVORI"
              : "ODUSTANI"}
          </div>
        </div>

        {this.state.showsNumbericKeyboard ? (
          <NumericKeyboard
            closeHandler={() => {
              this.onCloseNumericKeyboard();
            }}
            keyDownHandler={(value, isQuickPick) => {
              this.numericKeyboard_KeyDown(value, isQuickPick);
            }}
            customClass={ADJUSTED_FOR_PAYOUT_POPUP}
          />
        ) : null}
      </div>
    );
  }

  modalPopupBtnOk_Callback = () => {
    this.setState({ infoMessage: null });
  };

  btnPayoutMoney_Click() {
    this.setState({ isInPayout: true });
  }

  btnConfirmPayoutMoney_Click() {
    if (this.state.isPayoutActionsPaused) {
      return;
    }

    var msg = "";

    //validacija iznosa da je dividable s 10
    if (this.state.txtAmountPayoutValue === 0) {
      // alert(
      //   "Unesite željeni iznos isplate! Iznos mora biti okrugao (završavati s nulom, npr. 20, 50, 170)."
      // );

      msg = (
        <p>
          Unesite željeni iznos isplate! Iznos mora biti okrugao, odnosno
          završavati s nulom.
          <br />
          <br />
          Primjer ispravnih isplata:
          <br />
          10 BAM
          <br />
          20 BAM
          <br />
          70 BAM
          <br />
          120 BAM
        </p>
      );

      this.setState({ infoMessage: msg });

      return;
    }

    //provjeri iznos amount
    if (
      this.state.txtAmountPayoutValue >
      this.props.payoutReceiptInfo.AvailablePayOutAmountEUR
    ) {
      //alert("Iznos ne može biti veći od raspoloživog iznosa na potvrdi!");

      msg = (
        <p>
          Iznos ne može biti veći od raspoloživog iznosa na potvrdi!
          <br />
          <br />
          Raspoloživi iznos na potvrdi: &nbsp;
          {this.props.payoutReceiptInfo.AvailablePayOutAmountEUR.toFixed(2)} BAM
        </p>
      );

      this.setState({ infoMessage: msg });

      return;
    }

    //validacija iznosa da je dividable s 10
    if (this.state.txtAmountPayoutValue % 10 !== 0) {
      //alert("Iznos mora biti okrugao (završavati s nulom, npr. 20, 50, 170)!");

      msg = (
        <p>
          Iznos mora biti okrugao, odnosno završavati s nulom!
          <br />
          <br />
          Primjer ispravnih isplata:
          <br />
          10 BAM
          <br />
          20 BAM
          <br />
          70 BAM
          <br />
          120 BAM
        </p>
      );

      this.setState({ infoMessage: msg });

      return;
    }

    //gasi tipkovnicu
    this.setState({ showsNumbericKeyboard: false });

    //sve ok, zapocni isplatu9
    //alert("isplacujem " + this.state.txtAmountPayoutValue);

    //this.setState({ isPayoutInProgress: true });

    //rokaj
    window.cefCustomObject.checkForPossiblePayout(
      this.state.txtAmountPayoutValue
    );

    //this.setState({ isPayoutInProgess: true });
  }

  btnTransferToSaldo_Click() {
    this.setState({ isInTransferToSaldo: true });
  }

  btnConfirmTransferToSaldo_Click() {
    this.props.startLoading(false, false);

    //zovi servis
    PayoutToUserSession(
      this.props.machineInfo.MachineGUID,
      this.props.payoutReceiptInfo.ReceiptNumber,
      this.props.payoutReceiptInfo.SecurityCode,
      this.payoutToUserSession_Callback.bind(this)
    );
  }

  payoutToUserSession_Callback = val => {
    this.props.stopLoading(false);

    if (!val || val === "?") {
      //nemore
      alert("Greska prilikom prijenosa na saldo!");
      return;
    }

    val = parseInt(val, 10);

    if (val < 0) {
      //error neki
      alert("Neuspjesan prijenos na saldo! " + val);
      return;
    }

    //uspio prijenos, postavi na saldo
    this.props.updateBalance(val, true);

    //i azuriraj state sta imas
    this.setState({
      isTransferToSaldoCompleted: true,
      originalRealPayOutAmount: this.props.payoutReceiptInfo
        .AvailablePayOutAmountEUR
    });
  };

  btnCancel_Click() {
    if (this.state.isPayoutActionsPaused) {
      return;
    }

    if (this.state.isInPayout && !this.state.isPayoutCompleted) {
      //gasi payout
      this.setState({ isInPayout: false });
      return;
    }

    if (
      this.state.isInTransferToSaldo &&
      !this.state.isTransferToSaldoCompleted
    ) {
      //gasi payout
      this.setState({ isInTransferToSaldo: false });
      return;
    }

    //resetiraj state
    this.setState({
      isInPayout: false,
      isPayoutInProgess: false,
      isPayoutCompleted: false,
      isPayoutActionsPaused: false,
      isInTransferToSaldo: false,
      isTransferToSaldoCompleted: false,
      showsNumbericKeyboard: false,
      txtAmountPayoutValue: 0,
      totalDispendedAmount: 0,
      infoMessage: null
    });

    //gasi sve tipkovnice sigurno
    this.setState({ showsNumbericKeyboard: false });

    //zatvaraj popup
    this.props.setPayoutReceiptNumber(-1);
  }

  txtNumeric_Enter = id => {
    console.log(id);
    this.setState({ showsNumbericKeyboard: true, currentTextboxID: id });
  };

  onCloseNumericKeyboard = () => {
    this.setState({ showsNumbericKeyboard: false });
  };

  numericKeyboard_KeyDown = (value, isQuickPick) => {
    console.log("VALUE ", value);

    if (value === -1) {
      //decimala, ne hendlamo to
      return;
    }

    if (value === -2) {
      //delete
      this.setState({ txtAmountPayoutValue: 0 });
      return;
    }

    //popuni value
    var val = this.state.txtAmountPayoutValue * 10 + value;
    this.setState({ txtAmountPayoutValue: parseInt(val, 10) });
  };
}

const mapStateToProps = state => {
  return {
    currentPayoutReceiptNumber: state.rrNavigation.currentPayoutReceiptNumber,
    machineInfo: state.rrAppState.machineInfo
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPayoutReceiptNumber: ticketNumber =>
      dispatch(StoreActions.SetPayoutReceiptNumber(ticketNumber)),
    updateBalance: (amountInCents, updateLocalStorage) =>
      dispatch(StoreActions.UpdateBalance(amountInCents, updateLocalStorage)),
    startLoading: (isTransparent, updateLocalStorage) =>
      dispatch(StoreActions.StartLoading(isTransparent, updateLocalStorage)),
    stopLoading: updateLocalStorage =>
      dispatch(StoreActions.StopLoading(updateLocalStorage))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialPayoutPopup);



// WEBPACK FOOTER //
// ./src/Components/PartialPayoutPopup/PartialPayoutPopup.js